import React from 'react'
import HelpusCard2 from './HelpusCard2';

const HelpCard = ({Topic,TopicName}) => {
    var info=Topic;
  return (
    <div className='w-full py-1'>
    <h1 className='text-xl font-semibold '>{TopicName}</h1>
    {info.map((curElem,index)=>{
        return (
           <HelpusCard2 key={index} header={curElem.header} content={curElem.content} />
        );
    })}
   
    </div>
  )
}

export default HelpCard